/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/tabindex-no-positive */
import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useAuth } from './utilities/auth'
import { authHostname } from './api/ApiConfig'
import { TermsPage } from './page/docs/terms'
import { PrivacyPage } from './page/docs/policy'
import { SMEPage } from './page/sme'
import AwsOptimizationPage from './page/awsoptimization'

interface IAuthProviderWithNavigate {
    children?: React.ReactNode
}

export const noAuthPages = [
    'callback',
    'terms',
    'privacy',
    'sme',
    'awsoptimization',
    'cloudoptimization',
]
export const AuthProviderWithNavigate = ({
    children,
}: IAuthProviderWithNavigate) => {
    const [locationSearchParams, setSearchParams] = useSearchParams()
    const { isAuthenticated, isLoading, loginWithCode, error } = useAuth()
    const page = window.location.pathname.split('/')

    const isNoAuth =
        noAuthPages.includes(page[1]) ||
        window.location.hostname === 'costoptimizer.watadtech.om'

    useEffect(() => {
        if (
            locationSearchParams.get('code') !== null &&
            locationSearchParams.get('code') !== '' &&
            !isLoading &&
            error.message === '' &&
            !isAuthenticated
        ) {
            loginWithCode(locationSearchParams.get('code') || '')
        }

        if (!isAuthenticated && !isNoAuth) {
            const callback = `${window.location.origin}/callback`

            const searchParams = new URLSearchParams()
            searchParams.append('client_id', 'public-client')
            searchParams.append('redirect_uri', callback)
            searchParams.append('scope', 'openid email profile federated:id')
            searchParams.append('response_type', 'code')
            searchParams.toString()

            sessionStorage.setItem('callbackURL', window.location.href)

            window.location.href = `${authHostname()}/dex/auth?${searchParams.toString()}`
        }
    }, [])

    if (page[1] === 'terms') {
        return <TermsPage />
    }
    if (page[1] === 'privacy') {
        return <PrivacyPage />
    }
    if (page[1] === 'sme') {
        return <SMEPage />
    }
    if (
        page[1] === 'awsoptimization' ||
        page[1] === 'cloudoptimization' ||
        window.location.hostname === 'costoptimizer.watadtech.om'
    ) {
        return <AwsOptimizationPage />
    }

    return (
        <>
            <span />
            {children}
        </>
    )
}
